import { ColorEnum, Icon } from './icon';
import { IndeterminateIcon as IndeterminateIconIcon } from '../../../../../icons';

export const IndeterminateIcon = ({ color }: { color?: ColorEnum }) => (
  <Icon color={color} state="indeterminate">
    <IndeterminateIconIcon height={'inherit'} width={'inherit'} />
  </Icon>
);
